import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "_flex _fd-c--l _gap-2 _ai-c" }
const _hoisted_2 = ["href", "title"]
const _hoisted_3 = { class: "gfu-profile-card__media" }
const _hoisted_4 = { class: "gfu-profile-card__title _toe gfu-hd gfu-hd--h2" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  class: "_tc--light gfu-bt gfu-bt--caption",
  "data-qa": "user-card:FollowersCountText"
}
const _hoisted_7 = {
  class: "gfu-profile-card__badges",
  "data-qa": "badge:UserCardBadges"
}
const _hoisted_8 = {
  key: 0,
  class: "gfu-profile-card__follow"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_label = _resolveComponent("base-label")
  const _component_user_follow = _resolveComponent("user-follow")
  const _component_base_image = _resolveComponent("base-image")
  const _component_icon_base_label = _resolveComponent("icon-base-label")
  const _component_base_card = _resolveComponent("base-card")

  return (_openBlock(), _createBlock(_component_base_card, {
    class: "gfu-profile-card",
    "extended-wrapper-class": "gfu-profile-card__wrapper"
  }, _createSlots({
    labels: _withCtx(() => [
      _createVNode(_component_user_follow, {
        "user-url-name": $props.urlName,
        nickname: $props.nickname,
        "user-id": $props.userID
      }, {
        default: _withCtx(({ isFollowing }) => [
          isFollowing
            ? (_openBlock(), _createBlock(_component_base_label, {
                key: 0,
                theme: "accent",
                "data-qa": "user-card:FollowingBadge"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Profile.UserProfileCardFollowingBadge), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["user-url-name", "nickname", "user-id"])
    ]),
    media: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          href: $props.profileUrl,
          title: $props.nickname,
          class: "gfu-profile-card__avatar _ai-c gfu-embed gfu-embed--1x1"
        }, [
          _createVNode(_component_base_image, {
            src: $props.avatarImageUrl,
            alt: $props.nickname,
            class: "gfu-embed__item gfu-avatar gfu-avatar--clean",
            loading: "lazy"
          }, null, 8 /* PROPS */, ["src", "alt"])
        ], 8 /* PROPS */, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(['_max-w-100',{'_flex _gap-1': $options.isUserVerified}])
          }, [
            _createElementVNode("h4", _hoisted_4, [
              _createElementVNode("a", {
                href: $props.profileUrl,
                "data-qa": "user-card:Nickname"
              }, _toDisplayString($props.nickname), 9 /* TEXT, PROPS */, _hoisted_5)
            ]),
            ($options.isUserVerified)
              ? (_openBlock(), _createBlock(_component_icon_base_label, _mergeProps({ key: 0 }, $options.verifiedLabelModel, {
                  class: "gfu-profile-card__verified",
                  "data-qa": $options.verifiedLabelModel.dataQa
                }), null, 16 /* FULL_PROPS */, ["data-qa"]))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */),
          _createElementVNode("span", _hoisted_6, _toDisplayString($options.formattedFollowersLabel), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.userAchievedLabels, (label) => {
              return (_openBlock(), _createBlock(_component_icon_base_label, _mergeProps({
                key: label.name
              }, { ref_for: true }, label, {
                "data-qa": label.dataQa
              }), null, 16 /* FULL_PROPS */, ["data-qa"]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ]),
    _: 2 /* DYNAMIC */
  }, [
    ($options.isFollowUserActionVisible)
      ? {
          name: "actions",
          fn: _withCtx(() => [
            _createVNode(_component_user_follow, {
              "user-url-name": $props.urlName,
              nickname: $props.nickname,
              "user-id": $props.userID
            }, {
              default: _withCtx(({ isFollowing, onFollow, onUnfollow }) => [
                isFollowing
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.Resources.Profile.UserFollowingLabel), 1 /* TEXT */),
                      _createElementVNode("a", {
                        href: "#",
                        class: "_tc--accent",
                        onClick: _withModifiers(onUnfollow, ["prevent"]),
                        "data-qa": "user-card:Unfollow"
                      }, _toDisplayString(_ctx.Resources.Profile.UserUnfollowAction), 9 /* TEXT, PROPS */, _hoisted_9)
                    ]))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: "#",
                      class: "gfu-profile-card__follow _tc--accent",
                      onClick: _withModifiers(onFollow, ["prevent"]),
                      "data-qa": "user-card:Follow"
                    }, _toDisplayString(_ctx.Resources.Profile.UserProfileCardFollowThisUserAction), 9 /* TEXT, PROPS */, _hoisted_10))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["user-url-name", "nickname", "user-id"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1024 /* DYNAMIC_SLOTS */))
}